import React from 'react';

const Footer = (props) =>{
    return(
        <footer
            className={`${(props.isOrderConfirmed && !props.viewCompleteOrder && !props.isOrderCancelled) || (props.isOrderConfirmed && props.isOrderDone && props.viewCompleteOrder) ? 'absolute' : ''}`}>
            <p className="footer-links">
                <a href="http://www.bestwaycorp.it/Footer/Policy" target="_blank">Privacy Policy</a>
            </p>
        </footer>
    )
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js